import { render, staticRenderFns } from "./SchoolLeaveDetailModal.vue?vue&type=template&id=3e640fad&scoped=true&"
import script from "./SchoolLeaveDetailModal.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e640fad",
  null
  
)

export default component.exports